// CommunityIcon.tsx — controlled inline-SVG host for TRUSTED community icon
// strings only (seed constants + DEFAULT_COMMUNITY_ICON). Never pass user input.
import styled from 'styled-components';

const Box = styled.span<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex: 0 0 auto;
  /* Teal-HUD: category icons read MONOCHROME TEAL, shape carries the
     category, never color. Force the seed SVGs' (rainbow) stroke/fill to
     the single functional accent. */
  color: ${({ theme }) => theme.color.accentCyan};
  & svg { width: 64%; height: 64%; }
  & svg [stroke]:not([stroke='none']),
  & svg:not([stroke='none']) {
    stroke: currentColor;
  }
  & svg [fill]:not([fill='none']),
  & svg:not([fill='none']) {
    fill: currentColor;
  }
`;

export interface CommunityIconProps {
  /** Trusted inline SVG string from the community seed/default. */
  svg: string;
  size?: number;
}

export function CommunityIcon({ svg, size = 40 }: CommunityIconProps) {
  return <Box $size={size} aria-hidden dangerouslySetInnerHTML={{ __html: svg }} />;
}
